import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { AppConstants } from '../base/appconstants';
import { HttpService } from '../base/http.service';
import { URLStringFormatter } from '../base/url-string-formatter';
declare var require: any;
var jsPDF = require('jspdf');
require('jspdf-autotable');
import $ from 'jquery'
import { Observable } from 'rxjs';
declare var google: any;
import { Headers, RequestOptions } from '@angular/http';

@Component({
    selector: 'app-dailySummaryReports',
    templateUrl: './dailySummaryReports.component.html',
    styleUrls: ['./dailySummaryReports.component.scss']
})

export class DailySummaryReports implements OnInit {

    vehicleDetails: any = { 'result': [] };
    isTodayClicked: boolean = false;
    loading = false;
    data: any;
  asignedGpsDevice: any = [];
  defalultVehicle:any;

    public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'yyyy-mm-dd',
        disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }

    };

    public myDatePickerOptions2: IMyDpOptions = {
        // other options...
        dateFormat: 'yyyy-mm-dd',
        disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    };


    // Initialized to specific date (09.10.2018).
    public fromDate: any;
    public toDate: any;
    isSubmitClick: boolean = false;
    isPdfNotAvailable: boolean = true;
    userToken: any;
    userId: any;
    gpsDevicesArray: any = [];
    selectedVehicle: any;
    dashboardData: any;
    milage: any = "30";

    constructor(private httpService: HttpService, private urlFormatter: URLStringFormatter) {

    }

    ngOnInit() {

        this.userToken = localStorage.getItem("userToken");
        this.userId = localStorage.getItem("userId");
        this.getVehicleList();
    }

    getVehicleList() {
        let path = `${AppConstants.gps_devices}${this.userId}/gpsdevice`;
        let headers = new Headers({ 'accept': 'application/json', 'x-access-token': this.userToken }); //  ... Set content type to JSON
        let reqOptions = new RequestOptions({ headers: headers }); // Create a request option
        this.httpService.httpGetPromise(path, "", reqOptions).then((gpsDevicesResponse) => {
            this.gpsDevicesArray = gpsDevicesResponse.gpsDevices;
            this.selectedVehicle = this.gpsDevicesArray[0];
            this.gpsDevicesArray.forEach(element => {
              this.asignedGpsDevice.push(element.vehicleNumber);
            });
            this.defalultVehicle = this.asignedGpsDevice[0];
            // console.log('--------------oooooooooo0000000>>>>', this.gpsDevicesArray);
        })
    }

    onDateChanged(event: IMyDateModel) {


        if (event && event.jsdate) {
            let d: Date = new Date(event.jsdate.getTime());
            d.setDate(d.getDate() - 1);
            let copy: IMyDpOptions = this.getCopyOfEndDateOptions();
            copy.disableUntil = {
                year: d.getFullYear(),
                month: d.getMonth() + 1,
                day: d.getDate()
            };
            this.myDatePickerOptions2 = copy;
        }
    }

    getCopyOfEndDateOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerOptions2));
    }


    convert() {
        // let body = [];
        // body.push(this.dashboardData);
        // console.log("this.dashboardData ---" + JSON.stringify(this.dashboardData));

        let value = [];
        this.dashboardData.recordList.forEach(tripDateObj => {
            let subValueArray = [];
            subValueArray.push(tripDateObj.historyDate);
            subValueArray.push(tripDateObj.distanceTravelled);
            subValueArray.push(tripDateObj.fuelConsumed.toFixed(2));
            subValueArray.push(tripDateObj.runTime);
            subValueArray.push(tripDateObj.idleTime);
            subValueArray.push(tripDateObj.stoppageTime);
            subValueArray.push(tripDateObj.avgSpeed);
            subValueArray.push(tripDateObj.maxSpeed);
            subValueArray.push(tripDateObj.startingTime);
            subValueArray.push(tripDateObj.stopingTime);
            subValueArray.push(tripDateObj.startingPoint);
            subValueArray.push(tripDateObj.stopingPoint);
            value.push(subValueArray);
        });

        let headerName = "Daily Summary Report (" + this.fromDate.formatted + " to " + this.toDate.formatted + ")";

        let body = {
            "headerName": headerName,
            "excelName": "DailySummaryReport",
            "header": [
                "Date (M/D/Y)",
                "Total Distance (KM)",
                "Fuel Consumed (L)",
                "Total Run Time (Hours)",
                "Total Idle Time (Hours)",
                "Total Stoppage Time (Hours)",
                "Avg Speed (Km/hr)",
                "Max Speed (Km/hr)",
                "Start Time",
                "End Time",
                "Starting point",
                "Stopping point"
            ],
            "value": value
        }

        this.downloadExcelSheet(body).subscribe(blob => {
            // Doing it this way allows you to name the file
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "Report.xlsx";
            link.click();
        }, error => console.log("Error downloading the file."),
            () => console.log('Completed file download.'));
    }

    onClearClick() {
        this.isPdfNotAvailable = true;
        this.fromDate = null;
        this.toDate = null;
        this.isSubmitClick = false;
        this.vehicleDetails = null;
    }

    onMilageChange() {
        this.dashboardData.recordList.forEach(element => {
            element.fuelConsumed = (element.distanceTravelled / parseInt("" + this.milage));
        });
    }

    todaysDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

   async getTableData() {

        if (!(this.fromDate && this.fromDate.formatted)) {
            alert('Please select From Date first');
            return;
        }

        if (!(this.toDate && this.toDate.formatted)) {
            alert('Please select From Date first');
            return;
        }

        this.isSubmitClick = true;
        this.isPdfNotAvailable = true;
        this.loading = true;

        let dashBoardParams = {
            imeiNumber: this.selectedVehicle.imeiNumber,
            toDate: this.toDate.formatted,
            fromDate: this.fromDate.formatted
        }

        // console.log("req dashboarddata..............", JSON.stringify(dashBoardParams));

        let headers = new Headers({ 'accept': 'application/json', 'x-access-token': this.userToken }); //  ... Set content type to JSON
        let reqOptions = new RequestOptions({ headers: headers }); // Create a request option
        this.httpService.httpPostPromise(AppConstants.get_dashboard_data_for_report, dashBoardParams, "", reqOptions).then((dashboardData) => {
            // console.log("dashboarddata...Vino...........", JSON.stringify(dashboardData));
            this.isPdfNotAvailable = false;
            this.loading = false;
            if (dashboardData && dashboardData.statusCode === 200) {
                this.dashboardData = dashboardData;
                this.dashboardData.recordList.forEach( async element => {
                    let dateTimeStamp = new Date(element.historyDate).getTime();
                    element.historyTimeStamp = dateTimeStamp;
                    element.distanceTravelled = (((parseInt(element.distanceTravelled)*7)/100) + parseInt(element.distanceTravelled)).toFixed(2);
                    element.fuelConsumed = (element.distanceTravelled / parseInt("" + this.milage));

                    let path = `${AppConstants.Google_GeoCoding_API}latlng=${element.startLocation.lat},${element.startLocation.lng}`;
                    let headers = new Headers({ 'accept': 'application/json' }); // ... Set content type to JSON
                    let reqOptions = new RequestOptions({ headers: headers }); // Create a request option
                    try {
                        let addressObj = await this.httpService.httpGetPromise(path, "", reqOptions);
                        element.startingPoint =  addressObj.results[0].formatted_address;
                    }
                    catch (error) {
                        console.log(error)
                    }
                    let path2 = `${AppConstants.Google_GeoCoding_API}latlng=${element.endLocation.lat},${element.endLocation.lng}`;
                    try {
                        let addressObj = await this.httpService.httpGetPromise(path2, "", reqOptions);
                        element.stopingPoint =  addressObj.results[0].formatted_address;
                    }
                    catch (error) {
                        console.log(error)
                    }
                    element.startingTime = new Date(element.startLocation.timestamp).toLocaleTimeString();
                    element.stopingTime = new Date(element.endLocation.timestamp).toLocaleTimeString();
                });
                this.dashboardData.recordList.sort((a, b) => (a.historyTimeStamp > b.historyTimeStamp) ? 1 : ((b.historyTimeStamp > a.historyTimeStamp) ? -1 : 0));
            }
        }).catch((dashboardErr) => {
            this.loading = false;
            // console.log("dashboardErr...", JSON.stringify(dashboardErr));
        });
    }

    downloadExcelSheet(reqBody): Observable<Object[]> {
        this.loading = true;
        return Observable.create(observer => {
            let xhr = new XMLHttpRequest();
            xhr.open('POST', AppConstants.EXCEL_DOWNLOAD_URL + '/genericxls', true);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.responseType = 'blob';

            xhr.onreadystatechange = () => {
                this.loading = false;
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {

                        var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        var blob = new Blob([xhr.response], { type: contentType });
                        observer.next(blob);
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            }
            xhr.send(JSON.stringify(reqBody));

        });
    }

    onVehicleNumberChange(device) {
        this.selectedVehicle = device;
        this.getTableData();
    }
    doSelectVehical(event) {
      const vehicalNo = this.gpsDevicesArray.filter(vehicle=>vehicle.vehicleNumber === event);
      this.selectedVehicle = vehicalNo[0];
      console.log('doSelectVehical', event);
      console.log('selectedVehicle', this.selectedVehicle);
      this.getTableData();
    }
    doNgxDefault(){
      return this.defalultVehicle;
    }
}
